export default `
varying mediump vec3 modelPosition;

void main() {
  mediump vec3 modelVertex = position;
  modelPosition = vec3(modelVertex.x, -modelVertex.y, -modelVertex.z);
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`;
